/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { Grid } from '@material-ui/core';
import { toast } from 'react-toastify';
import Default from '../../contenedores/Default';
import TextField from '../../componentes/TextField';
import Select from '../../componentes/Select';
import axios from '../../configuraciones/axios';
import { findPropertysEmpty, trim } from '../../utilidades/functions';
import endpoints, {
  ENFERMEDADES,
  TIPOSENFERMEDADES,
} from '../../configuraciones/endpoints';
import estatus from '../../constantes/estatus';
import { ELEMENTO_NO_ENCONTRADO } from '../../configuraciones/mensajes';

const Enfermedad = ({ history, match }) => {
  const [enfermedad, setEnfermedad] = useState({});
  const [tipos, setTipos] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const { params: { id } } = match;

  const regresar = () => {
    const { location: { state: { pagina } } } = history;
    history.push({
      pathname: '/catalogos/enfermedades',
      search: pagina && pagina > 1 ? `?pagina=${pagina}` : '',
    });
  };

  const cancelar = useCallback(regresar, []);

  const guardar = useCallback(() => {
    const {
      errors, regex, totalErrors, totalRegex
    } = findPropertysEmpty(document.getElementById('frmEnfermedad'), true);
    setFormErrors({ ...errors, ...regex });
    if (totalErrors > 0 || totalRegex > 0) return;

    const metodo = id ? 'put' : 'post';

    const objTrim = trim(enfermedad);

    axios[metodo](ENFERMEDADES, objTrim).then(regresar);
  }, [enfermedad]);

  const consultarDatosIniciales = () => new Promise((resolve, reject) => {
    const promesas = [
      axios.get(endpoints.base.url(TIPOSENFERMEDADES)),
    ];
    if (id)
      promesas.push(axios.get(endpoints.base.url(ENFERMEDADES, id)));

    Promise.all(promesas).then((resultadosPromesas) => {
      const [tiposDb, enfermedadDb] = resultadosPromesas;
      setTipos(tiposDb);
      if (enfermedadDb?.id)
        setEnfermedad(enfermedadDb);
      else if (id) {
        toast.warning(ELEMENTO_NO_ENCONTRADO);
        regresar();
      } else
        setEnfermedad({estatus: true});
      resolve();
    }).catch(reject);
  });

  useEffect(() => {
    consultarDatosIniciales();
  }, [id]);

  return <Default
    titulo={Boolean(id) ? 'Editar Enfermedad' : 'Nueva Enfermedad'}
    placeHolder={''}
    mostrarCabeceroFormulario
    guardar={guardar}
    cancelar={cancelar}>
    <Grid container spacing={2} id="frmEnfermedad">
      <Grid item lg={4} md={4} sm={12} xs={12}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <TextField
              label="Nombre de Enfermedad"
              onChange={setEnfermedad}
              name="nombre"
              value={enfermedad.nombre}
              isHandleChange
              inputProps={{ maxLength: 50 }}
              error={formErrors.nombre}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Select
              label="Tipos"
              required
              options={tipos}
              labelProp="nombre"
              onChange={setEnfermedad}
              name="tipoEnfermedadID"
              value={enfermedad.tipoEnfermedadID || ''}
              error={formErrors.tipoEnfermedadID}
              isHandleChange
            />
          </Grid>
          <Grid item xs={12}>
            <Select
              label="Estatus"
              required
              options={estatus}
              onChange={setEnfermedad}
              name="estatus"
              value={enfermedad.estatus}
              error={formErrors.estatus}
              isHandleChange
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Default>;
};

export default React.memo(Enfermedad);
